import { useCallback } from "react";
import { postFetchData } from "../api/FetchData"; // Adjust the import as needed
import { APICONSTANT } from "../api/Config";
import { ToastNotifier } from "../../components/ui/ToastNotifier";
import { useDispatch } from "react-redux";
import { setDisabled } from "../../components/filter/districtDetailsFilter/store";
import CustomHookForRuralDetails from "../../components/ruralDetailsCount/CustomHookForRuralDetails";

interface UseFileUploadProps {
  setValue: (
    field: string,
    value: any,
    options?: { shouldValidate: boolean }
  ) => void;
}

const CommonServices = (props) => {
  const dispatch = useDispatch();
  const { ruralDetailsCount } = CustomHookForRuralDetails();

  const useFileUpload = ({ setValue }: UseFileUploadProps) => {
    const uploadFile = useCallback(
      async (file: File, apiName: string, fieldName: string) => {
        if (!file) return;
        const formData = new FormData();
        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 2) {
          ToastNotifier("File size must be 2 MB or less!", "error");
          return;
        }
        formData.append("filename", file);
        try {
          const filePath = await postFetchData(
            1,
            dispatch,
            `${APICONSTANT.file_upload}${apiName}`,
            formData
          );

          if (filePath?.status === 1) {
            setValue(fieldName, filePath.data.filename, {
              shouldValidate: true,
            });
          } else {
            ToastNotifier(
              "Error: File upload failed - Allowed extensions: .pdf, .jpeg, .jpg",
              "error"
            );
          }
        } catch (error) {
          ToastNotifier("Error uploading file. Please try again.", "error");
        }
      },
      [setValue]
    );
  };

  const handleApply = async (renderAbleId) => {
    dispatch(setDisabled(true));
    if (renderAbleId) {
      await Promise.all(
        renderAbleId?.map(async (id: any) => await ruralDetailsCount(id, props))
      );
    }
    dispatch(setDisabled(false));
  };

  const handleReset = async (clearAbleState, id) => {
    await Promise.all(
      clearAbleState?.map(([setData, setCode]) => [
        dispatch(setData([])),
        dispatch(setCode([])),
      ])
    );
    handleApply(id);
  };

  return { useFileUpload, handleReset, handleApply };
};

export default CommonServices;
